<template>
	<div class="labelSelect" :style="{width:componentWidth}">
		<span :style="{color:spanColor,fontSize:spanFontSize+'px',width:spanWidth,}" class="innerSpan">
			<span style="color: red;" v-if="spanRequired">*&nbsp;</span>
			{{spanTitle}}:
		</span>
		<div class="innerP">
			<el-date-picker v-model="value" :type="normalDate" :value-format="valueFormat" :placeholder="pelaceHolder"
				@change="selectChange">
			</el-date-picker>
		</div>
	</div>
</template>

<script>
	import {
		getLocation,
		getCity
	} from '../../api/moudles/user.js'
	export default {
		data() {
			return {
				value: this.outInput,
			}
		},
		computed: {
			selectWidth() {
				let licaoWidth = parseInt(100 / this.selectList.length - 1) + '%'
				// console.log(licaoWidth)
				return licaoWidth
			}
		},
		props: {
			normalDate: {
				type: String,
				default: 'date'
			},
			valueFormat: {
				type: String,
				default: 'yyyy-MM-dd'
			},
			// 默认组件宽度
			componentWidth: {
				type: String,
				default: '600px'
			},
			// span类
			spanColor: {
				type: String,
				default: '#000'
			},
			spanFontSize: {
				type: Number,
				default: 14
			},
			spanTitle: {
				type: String,
				default: '标题'
			},
			spanWidth: {
				type: String,
				default: '100px'
			},
			// 限制必填
			spanRequired: {
				type: Boolean,
				default: false
			},
			// pelaceHolder提示
			pelaceHolder: {
				type: String,
				default: '请选择'
			},
			// 绑定外部值
			outInput: {
				type: String,
				default: ''
			}
		},
		created() {

		},
		methods: {
			setTime(time) {
				this.value = time
			},
			selectChange(e) {
				this.$emit('selectDate', e)
			}
		}
	}
</script>

<style scoped>
	.labelSelect {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		margin: 10px 10px;
	}

	.innerSpan {
		display: inline-block;
		display: inherit;
		justify-content: flex-end;
	}

	.innerP {
		/* display: inline-block; */
		display: inherit;
		justify-content: space-between;
		/* justify-content: flex-start; */
		padding-left: 20px;
	}

	.el-select {
		width: 101%;
	}
</style>
